<!--
  功能：左右两端布局组件
  作者：lost
  邮箱：lost@daoyoudao.com
  时间：2021年06月04日 13:11:59
  版本：v1.0
-->
<template>
  <div>
    <el-row type="flex" justify="space-between" align="middle">
      <el-col>
        <!-- 前插槽 -->
        <!--有名字的叫具名插槽 没名字的叫匿名插槽 -->
        <div v-if="showBefore" class="before">
          <slot name="before" />
        </div>
      </el-col>
      <el-col>
        <el-row type="flex" justify="end">
          <!-- 后插槽 -->
          <slot name="after" />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'betweenRow',
  // 组件参数 接收来自父组件的数据
  props: {
    showBefore: {
      default: true,
      type: Boolean
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {}
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
  // 组件在内存中被创建
  created() {},
  /**
   * 组件被渲染到页面
   */
  mounted() {}
}
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/betweenRow.vue